import React from "react";

export const RiseStar = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.025 4.62298C2.093 4.82698 2.285 4.96498 2.5 4.96498C2.715 4.96498 2.906 4.82698 2.975 4.62298L3.396 3.35998L4.659 2.93898C4.863 2.87098 5.001 2.67998 5.001 2.46498C5.001 2.24998 4.863 2.05898 4.659 1.99098L3.396 1.56998L2.975 0.306977C2.838 -0.101023 2.163 -0.101023 2.026 0.306977L1.605 1.56998L0.342 1.99098C0.138 2.05898 0 2.24998 0 2.46498C0 2.67998 0.138 2.87098 0.342 2.93898L1.605 3.35998L2.025 4.62298Z"
      fill="url(#paint0_linear_21505_25368)"
    />
    <path
      d="M15.525 7.8029L10.99 6.0099L9.19702 1.4749C8.97002 0.902898 8.02902 0.902898 7.80202 1.4749L6.00902 6.0099L1.47402 7.8029C1.18802 7.9159 0.999023 8.1929 0.999023 8.4999C0.999023 8.8069 1.18702 9.0839 1.47402 9.1969L6.00902 10.9899L7.80202 15.5249C7.91502 15.8109 8.19202 15.9989 8.49902 15.9989C8.80602 15.9989 9.08302 15.8109 9.19602 15.5249L10.989 10.9899L15.524 9.1969C15.81 9.0839 15.999 8.8069 15.999 8.4999C15.999 8.1929 15.812 7.9159 15.525 7.8029Z"
      fill="url(#paint1_linear_21505_25368)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_21505_25368"
        x1="2.5005"
        y1="0.000976562"
        x2="2.5005"
        y2="4.96498"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6700" />
        <stop offset="0.139423" stopColor="#FF4431" />
        <stop offset="0.254808" stopColor="#F6194B" />
        <stop offset="0.384615" stopColor="#E60062" />
        <stop offset="0.533654" stopColor="#CD0077" />
        <stop offset="0.692308" stopColor="#AD0088" />
        <stop offset="0.798077" stopColor="#851694" />
        <stop offset="0.903846" stopColor="#532899" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_21505_25368"
        x1="2.08834"
        y1="1.0459"
        x2="14.9097"
        y2="15.9989"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6700" />
        <stop offset="0.139423" stopColor="#FF4431" />
        <stop offset="0.254808" stopColor="#F6194B" />
        <stop offset="0.384615" stopColor="#E60062" />
        <stop offset="0.533654" stopColor="#CD0077" />
        <stop offset="0.692308" stopColor="#AD0088" />
        <stop offset="0.798077" stopColor="#851694" />
        <stop offset="0.903846" stopColor="#532899" />
      </linearGradient>
    </defs>
  </svg>
);
